module.exports = __webpack_public_path__ + "img/blue-rustic-bg.616bc912.svg";